
function Optimize(id) {
  let intervalId = null;
  let safety = 0;
  var ret = null;

  ret = new Promise((resolve, reject) => {
    var url_variant = (new URLSearchParams(location.search)).get("variant");
    if (url_variant) {
      url_variant = 1 * url_variant;
      //console.log("google-optimize", "unknown", id, url_variant, "from querystring");
      resolve(
        {
          id: id,
          variant: url_variant
        }
      )
    } else {
      if (window.google_optimize !== undefined) {
        var variant = window.google_optimize.get(id);
        if (variant) {
          variant = 1 * variant;
          //console.log("google-optimize", "READY", id, variant);
          resolve(
            {
              id: id,
              variant: variant
            }
          )
        } else {
          //reject valid id, no variant
          reject("No variant for id " + id);
        }
      } else {
        var intervalId = setInterval(() => {
          if (window.google_optimize !== undefined) {
            var variant = window.google_optimize.get(id);
            if (variant) {
              variant = 1 * variant;
              //console.log("google-optimize", "READY", id, variant);
              resolve(
                {
                  id: id,
                  variant: variant
                }
              )
            } else {
              //reject valid id, no variant
              reject("No variant for id " + id);
            }

            clearInterval(intervalId);
          } else {
            //console.log("google-optimize", "NOT READY");
            safety = safety + 1;
            if (safety > 20) {
              clearInterval(intervalId);
              reject("google-optimize not ready after " + safety + " attempts");
            }
          }
        }, 100);
      }
    }

  });

  return ret;
};

export { Optimize };